import {Exclude, Expose, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {LevelType} from "./container-level-history";

export const LevelValidator = t.intersection([
    t.type({
        /* required props] */
    }),
    t.partial({
        level: t.number,
        levelUom: t.string,
        volume: t.number,
        volumeUom: t.string,
        dttm: t.number,
    }),
]);

export const LevelArrayValidator = t.array(LevelValidator);

export type Level = t.TypeOf<typeof LevelValidator>;
export type LevelArray = t.TypeOf<typeof LevelArrayValidator>;

@Exclude()
export class LevelEntity {
    @Expose({name: 'level'}) height?: number;
    @Expose({name: 'levelUom'}) heightUom?: string;
    @Expose() volume?: number;
    @Expose() volumeUom?: string;
    @Expose() dttm?: number;

    /**
     * Constructor for ContainerStatusEntity.
     * @hideconstructor
     */
    constructor() {
        // Empty constructor for 'class-transformer'
    }

    static from(plain: Level): LevelEntity {
        return plainToInstance(
            LevelEntity,
            plain,
            {
                excludeExtraneousValues: true,
            }
        );
    }

    getLevel = (levelType: LevelType): number | undefined => {
        if (levelType === 'height') {
            return this.height;
        } else if (levelType === 'volume') {
            return this.volume;
        }

        return undefined;
    };

    getLevelUom = (levelType: LevelType): string | undefined => {
        if (levelType === 'height') {
            return this.heightUom;
        } else if (levelType === 'volume') {
            return this.volumeUom;
        }

        return undefined;
    };
}
